import { LANGUAGES, type Language } from '@certhon/models';
import { z } from 'zod';
import {
  passwordFields,
  passwordsMatch,
} from '@/features/settings/settings.schemas';

/** Same loginname rule as the legacy activation form. */
export const LOGINNAME_PATTERN = /^[a-z0-9][a-z0-9_.]+[a-z0-9]+$/;

const LANGUAGE_LABELS: Record<Language, string> = {
  en: 'English',
  nl: 'Nederlands',
};

export const ACCOUNT_LANGUAGES = LANGUAGES.map((value) => ({
  value,
  label: LANGUAGE_LABELS[value],
}));

export function defaultLanguage(): Language {
  return navigator.language?.toLowerCase().startsWith('nl') ? 'nl' : 'en';
}

export const activateSchema = z
  .object({
    loginname: z
      .string()
      .trim()
      .toLowerCase()
      .min(3, 'Username should have at least 3 characters')
      .max(30, 'Username should have at most 30 characters')
      .regex(
        LOGINNAME_PATTERN,
        'Use lowercase letters, digits, dots and underscores only',
      ),
    language: z.string(),
    ...passwordFields,
  })
  .refine(passwordsMatch.check, passwordsMatch.options);

export type ActivateFormValues = z.infer<typeof activateSchema>;

export const forgotSchema = z.object({
  identifier: z.string().trim().min(1, 'Enter your username or email address'),
});

export type ForgotFormValues = z.infer<typeof forgotSchema>;

export const recoverSchema = z
  .object(passwordFields)
  .refine(passwordsMatch.check, passwordsMatch.options);

export type RecoverFormValues = z.infer<typeof recoverSchema>;
